// @ts-ignore Ignore unused commented ActionTypes import
import { TemplateState } from 'src/app/shared/models';

import { TemplateActions, TemplateActionTypes } from './actions';

export const initialState: TemplateState = {};

export function templateReducer(
  state: TemplateState = initialState,
  action: TemplateActions,
): TemplateState {
  switch (action.type) {
    case TemplateActionTypes.SetEditingTemplate: {
      return {
        ...state,
        editingTemplate: action.template,
      };
    }

    case TemplateActionTypes.SaveTreatment: {
      return {
        ...state,
        editingTemplate: {
          ...state.editingTemplate,
          treatments: (action.index > -1
            ? state.editingTemplate.treatments.map((treatment, index) =>
                index === action.index ? { ...action.treatment } : treatment,
              )
            : [...state.editingTemplate.treatments, action.treatment]
          ).sort((a, b) => {
            const firstPeriod = action.salesOrderPeriods.find(
              (salesOrderPeriod) => salesOrderPeriod.id === a.periodId,
            );
            const secondPeriod = action.salesOrderPeriods.find(
              (salesOrderPeriod) => salesOrderPeriod.id === b.periodId,
            );
            return firstPeriod && secondPeriod
              ? firstPeriod.periodNumber - secondPeriod.periodNumber
              : 0;
          }),
        },
      };
    }

    case TemplateActionTypes.RemoveTreatment: {
      return {
        ...state,
        editingTemplate: {
          ...state.editingTemplate,
          treatments: state.editingTemplate.treatments.filter(
            (treatment) => treatment.id !== action.treatment.id,
          ),
        },
      };
    }

    case TemplateActionTypes.SaveTreatmentSchema: {
      return {
        ...state,
        editingTemplate: {
          ...state.editingTemplate,
          treatmentSchemas: [
            ...state.editingTemplate.treatmentSchemas.filter(
              (treatmentSchema) => treatmentSchema.id !== action.treatmentSchema.id,
            ),
            { ...action.treatmentSchema },
          ],
        },
      };
    }

    case TemplateActionTypes.RemoveTreatmentSchema: {
      return {
        ...state,
        editingTemplate: {
          ...state.editingTemplate,
          treatmentSchemas: state.editingTemplate.treatmentSchemas.filter(
            (schema) => schema.id !== action.treatmentSchema.id,
          ),
        },
      };
    }

    default:
      return state;
  }
}
